var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCustomerService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 7.86959C11.333 7.63918 11.333 7.52398 11.3677 7.42127C11.4685 7.12292 11.7342 7.00713 12.0004 6.88588C12.2997 6.74957 12.4493 6.68142 12.5976 6.66943C12.7659 6.65581 12.9345 6.69208 13.0783 6.77282C13.2691 6.87985 13.4021 7.08325 13.5383 7.24864C14.1672 8.01252 14.4816 8.39447 14.5967 8.81566C14.6896 9.15557 14.6896 9.51102 14.5967 9.85092C14.4289 10.4652 13.8987 10.9802 13.5062 11.4569C13.3054 11.7007 13.2051 11.8226 13.0783 11.8938C12.9345 11.9745 12.7659 12.0108 12.5976 11.9972C12.4493 11.9852 12.2997 11.917 12.0004 11.7807C11.7342 11.6595 11.4685 11.5437 11.3677 11.2453C11.333 11.1426 11.333 11.0274 11.333 10.797V7.86959Z",
    stroke: "#242428"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 7.8697C4.66634 7.57954 4.65819 7.31876 4.42362 7.11476C4.33829 7.04056 4.22518 6.98903 3.99895 6.88599C3.69968 6.74968 3.55005 6.68153 3.40178 6.66954C2.95695 6.63356 2.71762 6.93716 2.46109 7.24875C1.83217 8.01263 1.51772 8.39458 1.40265 8.81577C1.30979 9.15568 1.30979 9.51113 1.40265 9.85103C1.57048 10.4654 2.10069 10.9803 2.49315 11.457C2.74053 11.7575 2.97685 12.0316 3.40178 11.9973C3.55005 11.9853 3.69968 11.9171 3.99895 11.7808C4.22518 11.6778 4.33829 11.6262 4.42362 11.552C4.65819 11.348 4.66634 11.0873 4.66634 10.7971V7.8697Z",
    stroke: "#242428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 7.00004V6.00004C13.3337 3.42271 10.9458 1.33337 8.00033 1.33337C5.05481 1.33337 2.66699 3.42271 2.66699 6.00004V7.00004",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 11.6666C13.3333 14.6666 10.6667 14.6666 8 14.6666",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomerService);
export default __webpack_public_path__ + "static/media/icon-customer-service.ee1ef19bae6e73f0ae4020f41f65c7a5.svg";
export { ForwardRef as ReactComponent };